module.exports = __webpack_public_path__ + "img/scene4-3.f731f635.jpg";